export default "__VITE_ASSET__BuYo9fi0__"